import React from 'react';

import { TouchableOpacity, View } from 'react-native';

import { useTranslation } from 'react-i18next';

import { LANGUAGE_KEYS } from 'config/languageKeys';
import { EPG_PROGRAM_NO_INFORMATION_ID } from 'config/testID';

import { isWeb } from 'utils/responsiveness';

import Text, { ETextCategory, ETextColor } from 'components/Text';
import { textColorStyles } from 'components/Text/styles';

import styles from './styles';

type Props = {
    playing: boolean;
    isChannelSubscribed?: boolean;
    handlePress?: () => void;
};

function EpgNoDataRow({ playing, isChannelSubscribed, handlePress }: Props) {
    const { t } = useTranslation();

    return (
        <TouchableOpacity
            style={[styles.root, playing && styles.playing]}
            activeOpacity={1}
            onPress={handlePress}
            testID={EPG_PROGRAM_NO_INFORMATION_ID}
        >
            <Text
                numberOfLines={1}
                ellipsizeMode="tail"
                category={ETextCategory.body2}
                color={ETextColor.neutral}
                style={[
                    isWeb && styles.webStickyText,
                    playing && [textColorStyles.black, styles.boldText],
                ]}
            >
                {t(LANGUAGE_KEYS.EPG.EPG_NO_INFO)}
            </Text>
            {!isChannelSubscribed && (
                <View style={styles.unsubscribedOverlay} />
            )}
        </TouchableOpacity>
    );
}

export default EpgNoDataRow;
